<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" slot="detail" :model="model" :rules="validatorRules" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('工单信息') }}</a-divider>
              <detail-list :col="3">
                <detail-list-item :term="$t('工单编号')">{{ model.ticketsNum }}</detail-list-item>
                <detail-list-item :term="$t('工单类型')">{{ model.ticketsType == 0 ? $t('换表') : '' }}</detail-list-item>
                <detail-list-item :term="$t('工单联系人')">{{ model.ticketsContact }}</detail-list-item>
              </detail-list>

              <detail-list :col="3">
                <detail-list-item :term="$t('紧急程度')">
                  <a-tag :color="getTagColor(model.ticketsEmergency)">
                    {{ setJJ(model.ticketsEmergency) }}
                  </a-tag>
                </detail-list-item>
                <detail-list-item :term="$t('预约时间')">{{ model.ticketsDeadline }}</detail-list-item>
                <!-- <detail-list-item term="地理信息">{{model.ticketsLocation}}</detail-list-item> -->

                <detail-list-item :term="$t('联系电话')">{{ model.ticketsContactPhone }}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('备注信息')" :itemCol="1">{{
                  model.ticketsChangeMeter && model.ticketsChangeMeter.changingMeterReasonDetail
                }}</detail-list-item>
              </detail-list>
            </a-col>
            <!-- <a-col :span="24">
              <a-form-model-item label="是否已解决" prop="audit">
                <a-radio-group v-model="model.audit">
                  <a-radio :value="1">已解决</a-radio>
                  <a-radio :value="0">未解决</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col> -->
            <a-col v-if="JSON.stringify(userInfo) != '{}'" :span="24">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
              <detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('用户编号')">{{ userInfo.userId }}</detail-list-item>
                  <detail-list-item :term="$t('用户姓名')">{{ userInfo.userName }}</detail-list-item>
                  <detail-list-item :term="$t('手机号码')">{{ userInfo.userPhone }}</detail-list-item>
                </detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('开户时间')">{{ userInfo.userCreateTime }}</detail-list-item>
                  <detail-list-item :term="$t('用水性质')">{{ userInfo.wtName }}</detail-list-item>
                  <detail-list-item :term="$t('用水状态')">{{
                    userInfo.userState == 0 ? $t('未开始计费') : userInfo.userState == 1 ? $t('已开始计费') : ''
                  }}</detail-list-item>
                </detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ userInfo.userAreaName }}</detail-list-item>
                  <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ userInfo.userAddr }}</detail-list-item>
                  <!-- <detail-list-item term="用户地址" :itemCol="1">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
                </detail-list>
                <!-- <detail-list :col="3">
                    <detail-list-item term="开户时间">{{userInfo.userCreateTime}}</detail-list-item>
                    <detail-list-item term="用户地址">{{userInfo.userAddr}}</detail-list-item>
                    <detail-list-item term="区域信息">{{userInfo?.userAreaName?.slice(userInfo.userAreaName.indexOf('-')+1,userInfo.userAreaName?.length)+'-'+userInfo?.userAddr}}</detail-list-item>
                </detail-list> -->
                <!--             
                <detail-list-item term="身份证号">{{userInfo.userIdNumber}}</detail-list-item>
                <detail-list-item term="身份类型">{{userInfo.userIdType== 1?'自然人': '企业'}}</detail-list-item>
                <detail-list-item term="建档日期">{{userInfo.createTime}}</detail-list-item>
                <detail-list-item term="激活时间">{{userInfo.userActivateTime}}</detail-list-item>
                <detail-list-item term="激活人">{{userInfo.userActivateBy}}</detail-list-item>
                <detail-list-item term="是否整数计费">{{userInfo.isIntegerBilling==1?'是':'否'}}</detail-list-item> -->
              </detail-list>
              <!-- <detail-list :col="1">
                <detail-list-item term="区域信息">{{userInfo.userAreaName.slice(userInfo.userAreaName.indexOf('-')+1,userInfo.userAreaName.length)+'-'+userInfo.userAddr}}</detail-list-item>
              </detail-list> -->
            </a-col>
            <a-col v-if="model.oldMeterId" :span="24">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表具信息') }}</a-divider>
              <detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('旧表编号')">{{ model.oldMeterId }}</detail-list-item>
                  <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                  <detail-list-item :term="$t('水表厂家')">{{ oldMeter.meterTypeName }}</detail-list-item>
                  <detail-list-item :term="$t('口径')">{{
                    oldMeter.mtCaliber ? 'DN' + oldMeter.mtCaliber : ''
                  }}</detail-list-item>
                </detail-list>
                <template v-if="model.isSolve == 1">
                  <detail-list :col="3">
                    <detail-list-item :term="$t('表计费起始读数(m³)')">{{
                      model.ticketsChangeMeter && model.ticketsChangeMeter.oldMeterStartNum
                    }}</detail-list-item>
                    <detail-list-item :term="$t('末次上报结算流量(m³)')">{{
                      model.ticketsChangeMeter && model.ticketsChangeMeter.oldUserCalNum
                    }}</detail-list-item>
                    <detail-list-item :term="$t('末次上报结算余额(元)')">{{
                      model.ticketsChangeMeter && model.ticketsChangeMeter.userAccountNum
                    }}</detail-list-item>
                  </detail-list>
                  <detail-list :col="3">
                    <detail-list-item :term="$t('末次上报日期')">{{
                      model.ticketsChangeMeter && model.ticketsChangeMeter.meterUpTime
                    }}</detail-list-item>
                  </detail-list>
                </template>
                <template v-else>
                  <detail-list :col="3">
                    <detail-list-item :term="$t('表计费起始读数(m³)')">{{
                      userInfo && userInfo.userMeterStartNum
                    }}</detail-list-item>
                    <detail-list-item :term="$t('末次上报结算流量(m³)')">{{
                      model && model.oldUserCalNum
                    }}</detail-list-item>
                    <detail-list-item :term="$t('末次上报结算余额(元)')">{{
                      userInfo && userInfo.userAccountNum
                    }}</detail-list-item>
                  </detail-list>
                  <detail-list :col="3">
                    <detail-list-item :term="$t('末次上报日期')">{{
                      model && model.meterUpTime
                    }}</detail-list-item>
                  </detail-list>
                </template>
                <!-- <detail-list-item term="旧表机械读数(m³)"  v-if="model.ticketsState > 1">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterOldMachineSumFlow}}</detail-list-item> -->
                <!-- <detail-list-item term="是否以旧表机械读数结算" v-if="model.ticketsState > 1">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.whetherSettlementOldTable == 1?'是':'否'}}</detail-list-item> -->
                <!-- <detail-list :col="3">
                    <detail-list-item term="结算流量(m³)">{{oldMeter.oldUserCalNum}}</detail-list-item>
                    <detail-list-item term="剩余金额(元)">{{oldMeter.userAccountNum}}</detail-list-item>
                </detail-list> -->
                <!--                 
                <detail-list-item term="旧表机械读数(m³)">{{model.meterOldMachineSumFlow}}</detail-list-item>
                <detail-list-item term="表计费起始读数(m³)">{{model.oldMeterStartNum == '0.000'?'0.00':model.oldMeterStartNum}}</detail-list-item>
                <detail-list-item term="表安装地址">{{model.userMeterAddr}}</detail-list-item>
                <detail-list-item term="末次上报读数(m³)">{{model.meterOldSumFlowAfterChange}}</detail-list-item>
                <detail-list-item term="末次上报结算余额(元)">{{model.userAccountNum}}</detail-list-item>
                <detail-list-item term="末次上报结算流量(m³)">{{model.oldUserCalNum}}</detail-list-item> -->
              </detail-list>

              <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>
              <a-button type="primary" style="margin-bottom: 10px" v-if="!notInput" icon="plus" @click="selectNewMeter"
                >{{ $t('选择新表') }}</a-button
              >
              <detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('新表编号')">{{ model.newMeterId }}</detail-list-item>
                  <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                  <detail-list-item :term="$t('新表厂商')">{{ model.newMtName }}</detail-list-item>
                  <detail-list-item :term="$t('口径')">{{
                    model.newMtCaliber ? 'DN' + model.newMtCaliber : ''
                  }}</detail-list-item>
                </detail-list>
              </detail-list>

              <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('旧表机械读数(m³)')" prop="meterOldMachineSumFlow">
                    <a-input-number
                      v-model="model.meterOldMachineSumFlow"
                      :placeholder="$t('请输入旧表机械读数')"
                      :min="0"
                      :precision="2"
                      style="width: 100%"
                      :disabled="notInput"
                      @change="meterOldMachineSumFlowInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('新表开始计费读数(m³)')" prop="meterStartNum">
                    <a-input-number
                      v-model="model.meterStartNum"
                      :min="0"
                      :precision="2"
                      style="width: 100%"
                      :placeholder="$t('请输入起始读数')"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col v-if="!(notInput && !model.resolvedPictureFront)" :span="12">
                  <a-form-model-item :label="$t('旧表照片')" prop="resolvedPictureFront">
                    <j-image-upload
                      v-model="model.resolvedPictureFront"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :disabled="notInput"
                      :isMultiple="true"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="!(notInput && !model.resolvedPictureOpposite)" :span="12">
                  <a-form-model-item :label="$t('新表照片')" prop="resolvedPictureOpposite">
                    <j-image-upload
                      v-model="model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :isMultiple="true"
                      :disabled="notInput"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('是否以旧表机械读数结算')"
                    prop="whetherSettlementOldTable"
                    :rules="whetherSettlementOldTableRules"
                  >
                    <a-select
                      v-model="model.whetherSettlementOldTable"
                      :placeholder="$t('请选择是否以旧表机械读数结算')"
                      @change="whetherSettlementOldTableChange"
                      :allowClear="true"
                    >
                      <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item :label="$t('是否收费')" prop="payOrNot">
                    <a-select
                      v-model="model.payOrNot"
                      :placeholder="$t('请选择是否收费')"
                      :disabled="notInput"
                      @change="payOrNotChange"
                    >
                      <a-select-option :value="1">{{ $t('收费') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不收费') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('剩余金额(元)')"
                    prop="meterUserAccountNumAfterChange"
                    :rules="meterUserAccountNumAfterChangeRules"
                  >
                    <a-input-number
                      v-model="model.meterUserAccountNumAfterChange"
                      :suffix="$t('元')"
                      :placeholder="$t('请输入剩余金额')"
                      :precision="2"
                      style="width: 100%"
                      :disabled="model.whetherSettlementOldTable == 1"
                    />
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item :label="$t('换表原因')" prop="changingMeterReason">
                    <a-cascader
                      v-model="changingMeterReason"
                      :options="options"
                      expand-trigger="hover"
                      :placeholder="$t('请选择换表原因')"
                      :disabled="notInput"
                      @change="onChange"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <!-- <a-row :gutter="24" v-if="notInput">
                <a-col :span="12">
                  <a-form-model-item label="电子签名" prop="payMoney">
                    <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false" v-if="model.electronicSignature">
                      <img style="width: 180px; height: 80px" :src="model.electronicSignature" />
                      <div class="mask-sig" :class="{ 'mask-show': isShow }">
                        <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                        <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                      </div>
                    </div>
                    <i v-else>暂无签名</i>
                  </a-form-model-item>
                </a-col>
              </a-row> -->
              <a-row :gutter="24">
                <a-col :span="12"  v-if="notInput">
                  <a-form-model-item :label="$t('电子签名')" prop="payMoney">
                    <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false" v-if="model.electronicSignature">
                      <img style="width: 180px; height: 80px" :src="model.electronicSignature" />
                      <div class="mask-sig" :class="{ 'mask-show': isShow }">
                        <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                        <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                      </div>
                    </div>
                    <i v-else>{{ $t('暂无签名') }}</i>
                  </a-form-model-item>
                </a-col>
                <a-col
                  v-if="model.payOrNot == 1 && !(notInput && !model.resolvedPictureOpposite) && !notInput"
                  :span="12"
                >
                  <a-form-model-item :label="$t('付款码')" prop="paymentCode">
                    <a-upload
                      action=""
                      list-type="picture-card"
                      :file-list="qrcodeImage"
                      @preview="handlePreview"
                      disabled
                    >
                    </a-upload>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="model.payOrNot == 1 && !(notInput && !model.resolvedPictureOpposite)" :span="12">
                  <a-form-model-item :label="$t('支付凭证')" prop="infoPicture">
                    <j-image-upload
                      v-model="model.infoPicture"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :isMultiple="true"
                      :disabled="notInput"
                    ></j-image-upload>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24" v-if="model.payOrNot == 1">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('收费金额(元)')"
                    prop="feeAmount"
                  >
                    <a-input-number
                      v-model="model.feeAmount"
                      :suffix="$t('元')"
                      :precision="2"
                      :min="0"
                      style="width: 100%"
                      :placeholder="$t('请输入收费金额')"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('协议书照片')" prop="protocolPicture">
                    <j-image-upload
                      v-model="model.protocolPicture"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                      @change="handleImageChange"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="!notInput" :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :label="$t('换表原因描述')" prop="remark">
                    <a-textarea v-model="model.remark" :placeholder="$t('请输入换表原因描述')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row v-if="notInput" :gutter="24">
                <a-col :span="24">
                  <detail-list :col="3">
                    <detail-list-item :term="$t('换表原因描述')" :itemCol="1">{{
                      model.ticketsChangeMeter && model.ticketsChangeMeter.remark
                    }}</detail-list-item>
                  </detail-list>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item :label="$t('备注')" prop="approveRemark">
                    <a-textarea v-model="approveRemark" :placeholder="$t('请输入备注')" :rows="4" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <newMeterModal ref="newMeterForm" @ok="loadData"></newMeterModal>
    <!-- 选择新表弹窗 -->
    <SelectNewMeterModal
      :visible="selectNewMeterModalVisible"
      @update:visible="val => (selectNewMeterModalVisible = val)"
      @ok="handleMeterSelected"
    />
    <j-modal
      :title="$t('预览')"
      :width="448"
      :visible="visibleSig"
      @cancel="handleSigCancel"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <div style="width: 400px; height: 400px">
        <img :src="model.ticketsChangeMeter&&model.ticketsChangeMeter.electronicSignature" alt="" style="width: 100%; height: 100%" />
      </div>
    </j-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel1">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </j-modal>
</template>

<script>
// import {
//   JeecgListMixin
// } from '@/mixins/JeecgListMixin';
import { httpAction, getAction, postAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import DetailList from '@/components/tools/DetailList'
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import newMeterModal from './newMeterModal.vue'
import SelectNewMeterModal from './selectNewMeter.vue'
const DetailListItem = DetailList.Item
import {fileUrl} from'@/utils/util'
export default {
  // mixins: [JeecgListMixin],
  name: 'AuditModal',
  components: {
    DetailList,
    JUpload,
    JImageUpload,
    DetailListItem,
    JSelectUserByDep,
    newMeterModal,
    SelectNewMeterModal,
  },
  data() {
    const validateRemark = (rule, value, callback) => {
      if (this.model.audit == 0) {
        if (value) {
          callback()
        } else {
          callback(new Error(this.$t('请输入备注')))
        }
      } else {
        callback()
      }
    }
    return {
      title: '',
      optionType: '',
      approveRemark: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      previewVisible: false,
      notInput: false, // 审批 不允许输入
      selectNewMeterModalVisible: false,
      selectedMeter: null,
      qrcodeImage: [
        {
          uid: '-1',
          name: '付款码',
          status: 'done',
          url: fileUrl+'/file/payment_code.png',
        }
      ],
      previewVisible: false,
      previewImage: '',
      model: {
        meterUserAccountNumAfterChange: null,
      },
      url: {
        list: '/jeecg-charge/meter/meterUserinfo/list',
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        userList: '/jeecg-engineering/ticket/ticketsUser/list',
        editApproverName: '/jeecg-engineering/ticket/tickets/editApproverName',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        useOldMachineSumFlow: '/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow', // 是否以旧表读数结算
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', // 新表接口
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId', // 换表请求
        // 测试
      },
      candidateUsersList: [],
      changingMeterReason: [],
      oldMeter: {},
      newMeter: {},
      userInfo: {},
      isShow: false,
      visibleSig: false,
    }
  },
  computed: {
    validatorRules() {
      return {
        audit: { required: true, message: this.$t('请选择审批意见'), trigger: 'change' },
        candidateUsers: { required: true, message: this.$t('请选择下一节点操作人'), trigger: 'change' },
        payOrNot: { required: false, message: this.$t('请选择是否收费'), trigger: 'change' },
        feeAmount: { required: true, message: this.$t('请输入收费金额'), trigger: 'change' },
        protocolPicture: { required: true, message: this.$t('请上传协议书照片'), trigger: 'change' },
        whetherSettlementOldTable: { required: false, message: this.$t('请选择是否是否以旧表机械读数结算'), trigger: 'change' },
        meterOldMachineSumFlow: [
          { required: true, message: this.$t('请输入机械读数') },
          { pattern: /^\d*\.?\d+$/, message: this.$t('必须为数字') },
        ],
        userAccountNum: [
          { required: true, message: this.$t('请输入剩余金额') },
          { type: 'number', message: this.$t('必须为数字') },
        ],
        resolvedPictureFront: [{ required: true, message: this.$t('请上传旧表照片') }],
        resolvedPictureOpposite: [{ required: true, message: this.$t('请上传新表照片') }],
        infoPicture: [{ required: true, message: this.$t('请上传新表照片') }],
        changingMeterReason: [{ required: true, message: this.$t('请选择换表原因') }],
        remark: [{ required: !(this.model.audit == 1), message: this.$t('请输入换表原因描述') }],
        newMeterId: [
          { required: true, message: this.$t('请输入新表编号'), trigger: 'blur' },
          { pattern: /^[A-Za-z0-9-]+$/, message: this.$t('只允许字母、数字和横线') },
        ],
        meterStartNum: [
          { required: true, message: this.$t('请输入起始读数'), trigger: 'blur' },
          { type: 'number', message: this.$t('必须为数字值') },
        ],
      }
    },
    options() {
      const t = this.$t
      return [
        {
          value: '0',
          label: t('周期性换表'),
        },
        {
          value: '1',
          label: t('故障换表'),
          children: [
            {
              value: '2',
              label: t('基表问题'),
              children: [
                {
                  value: '3',
                  label: t('计量问题'),
                },
                {
                  value: '4',
                  label: t('阀门故障'),
                },
                {
                  value: '5',
                  label: t('基表爆裂'),
                },
              ],
            },
            {
              value: '6',
              label: t('电子问题'),
              children: [
                {
                  value: '7',
                  label: t('不上传数据'),
                },
                {
                  value: '8',
                  label: t('水表无反应（黑屏，无法激活）'),
                },
              ],
            },
            {
              value: '9',
              label: t('磁干扰'),
            },
            {
              value: '10',
              label: t('缺电'),
            },
            {
              value: '11',
              label: t('其他'),
            },
          ],
        },
      ]
    },
    whetherSettlementOldTableRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput ? [{ required: true, message: this.$t('请选择是否以旧表机械读数结算'), trigger: 'change' }] : []
    },
    meterUserAccountNumAfterChangeRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput ? [{ required: true, message: this.$t('请输入剩余金额'), trigger: 'blur' }] : []
    },
  },
  methods: {
    getUserList() {
      getAction(this.url.userList, { pageSize: 999 }).then(res => {
        if (res.success) {
          this.candidateUsersList = res.result.records || {}
        }
      })
    },
    init(row, type) {
      const that = this
      this.title = this.$t(type)
      this.optionType = type
      this.approveRemark = ''
      this.visible = true
      if (type == '审核') {
        this.notInput = true
      } else {
        this.notInput = false
      }
      this.model = {}
      this.model.id = row.id
      this.model.ticketsType = row.ticketsType
      this.model.ticketsId = row.id
      this.model.ticketsState = row.ticketsState
      this.getUserList()
      // 获取工单信息
      // 获取工单信息
      getAction(this.url.queryById, { id: row.id }).then(res => {
        if (res.success) {
          that.model = {
            ...res.result,
            ...res.result.ticketsChangeMeter,
            ...that.model,
          }
          that.userInfo = res.result.user || {}
          // if(type){// 旧表审核
          //   this.model = res.result.ticketsChangeMeter;
          //   this.userInfo = res.result.user;
          //   // this.newMeter = {};
          // }else{
          //   this.model = res.result.ticketsChangeMeter;
          //   this.userInfo = res.result.user;
          //   // this.oldMeter = {};
          // }
          // 审核 则备注填空
          if (that.notInput) {
            that.model.remark = ''
          }
          if (that.model.infoPicture) {
            this.$set(that.model, 'payOrNot', 1)
          } else {
            this.$set(that.model, 'payOrNot', 0)
          }
          if (that.model.ticketsChangeMeter && that.model.ticketsChangeMeter.changingMeterReason != null) {
            // 将后端返回的最后一层值转换为完整路径
            const fullPath = that.findCascaderPath(that.model.ticketsChangeMeter.changingMeterReason)
            that.changingMeterReason = fullPath
          }
          if (that.model.ticketsChangeMeter && that.model.ticketsChangeMeter.whetherSettlementOldTable == null) {
            this.$set(that.model, 'whetherSettlementOldTable', undefined)
          }

          // 获取旧表信息
          getAction(this.url.list, { meterId: res.result.ticketsChangeMeter.oldMeterId }).then(res => {
            if (res.success) {
              this.$set(that, 'userInfo', {
                ...(res.result.records[0] || {}),
                ...that.userInfo,
              })

              that.oldMeter = res.result.records[0] || {}
              this.$set(that.model, 'wtName', that.oldMeter.wtName)
              this.$set(that.model, 'meterTypeName', that.oldMeter.meterTypeName)
              this.$set(that.model, 'mtCaliber', that.oldMeter.mtCaliber)
              // this.$set(that.model, 'oldUserCalNum', that.oldMeter.oldUserCalNum)
              this.$set(that.model, 'userAccountNum', that.oldMeter.userAccountNum)
              this.$set(that.model, 'oldMeterStartNum', that.oldMeter.userMeterStartNum)

              that.meterOldMachineSumFlowInput()

              console.log('this.model', that.model)
            }
          })

          getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.model.ticketsChangeMeter.userKeyId }).then(
            res => {
              if (res.success) {
                this.$set(that.model, 'meterUpTime', res.result.meterUpTime)
                this.$set(that.model, 'oldUserCalNum', res.result.userCalNum)
              }
            }
          )

          // 获取新表信息
          if (that.model.newMeterId) {
            const params = {
              meterId: that.model.newMeterId,
            }
            getAction(that.url.newMeterInfo, params).then(res => {
              if (res.success) {
                that.newMeter = res.result.records[0] || {}
                this.$set(that.model, 'newMtCaliber', that.newMeter.mtCaliber)
                this.$set(that.model, 'newMtName', that.newMeter.mtName)
              }
            })
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      const that = this
      if (!this.model.newMeterId) {
        that.$message.warning(this.$t('请选择新表'))
        return
      }
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true

          let httpurl = ''
          let params = {}
          if (this.optionType == '处理') {
            httpurl += this.url.pass
            params = {
              // candidateUsers: that.model.candidateUsers,
              dataId: that.model.ticketsId,
              createTicketDTO: {
                resolvedPictureFront: that.model.resolvedPictureFront,
                resolvedPictureOpposite: that.model.resolvedPictureOpposite,
                infoPicture: that.model.infoPicture,
                ticketsChangeMeterReq: {
                  newMeterId: that.model.newMeterId,
                  meterStartNum: that.model.meterStartNum,
                  changingMeterReason: that.model.changingMeterReason,
                  // 换表原因
                  changingMeterReasonDetail: that.model.changingMeterReasonDetail, // 创建换表工单 备注
                  whetherSettlementOldTable: that.model.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                  resolvedPictureFront: that.model.resolvedPictureFront,
                  resolvedPictureOpposite: that.model.resolvedPictureOpposite,
                  infoPicture: that.model.infoPicture,
                  remark: that.model.remark, // 处理备注
                  oldMeterStartNum: that.model.oldMeterStartNum,
                  oldUserCalNum: that.model.oldUserCalNum,
                  userAccountNum: that.model.userAccountNum,
                  meterUpTime: that.model.meterUpTime,
                },
              },
              comment: '',
            }
            if(that.model.payOrNot==1){
              params.createTicketDTO.ticketsChangeMeterReq.feeAmount = that.model.feeAmount;
              params.createTicketDTO.ticketsChangeMeterReq.protocolPicture = that.model.protocolPicture;
            }
          } else {
            // 审核
            httpurl += this.url.pass
            params = {
              dataId: that.model.ticketsId,
              createTicketDTO: {
                ticketsChangeMeterReq: {
                  whetherSettlementOldTable: this.model.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  meterUserAccountNumAfterChange: this.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterStartNum: this.model.meterStartNum, // 新表开始计费读数
                },
              },
              comment: this.approveRemark,
            }
          }
          postAction(httpurl, params)
            .then(res => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'))
                that.$emit('ok')
                this.visible = false
                that.confirmLoading = false
                // 更新节点处理人
                // postAction(that.url.editApproverName,{
                //   ticketsId: that.model.ticketsId,
                //   ticketsType: that.model.ticketsType,
                //   approverName: that.model.candidateUsers.join(','),
                // }).then(val=>{
                //   if(res.success){
                //     // that.$message.success('更新节点处理人成功');
                //     that.$message.success('操作成功');
                //     that.$emit('ok');
                //     this.visible = false;
                //   }
                // });
              } else {
                that.confirmLoading = false
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error(this.$t('只能上传图片文件!'))
      }
      return isImage
    },
    downloadQRCode() {
      const link = document.createElement('a')
      link.href = this.qrcodeImage
      link.download = '付款二维码.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    meterOldMachineSumFlowInput() {
      if (this.model.whetherSettlementOldTable == 1) {
        console.log(this.userInfo)

        const params = {
          meterOldMachineSumFlow: this.model.meterOldMachineSumFlow,
          userId: this.userInfo.userId,
          meterIdOld: this.model.oldMeterId,
          userKeyId: this.model.userKeyId,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.model, 'meterUserAccountNumAfterChange', res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    // 选择新表
    selectNewMeter() {
      this.selectNewMeterModalVisible = true
    },
    handleMeterSelected(selectedMeter) {
      this.selectedMeter = selectedMeter
      // 新表编号
      this.model.newMeterId = selectedMeter.meterId
      // 新表口径
      this.model.newMtCaliber = selectedMeter.mtCaliber
      // 新表厂商 =
      this.model.newMtName = selectedMeter.mtName

      console.log('选中的表信息:', selectedMeter)
      // 这里可以处理选中的表信息，比如保存到父组件的数据中
    },
    onChange(value) {
      // value 是级联选择器的完整路径数组，如 ["1", "2", "3"]
      if (value && value.length > 0) {
        // 获取最后一层的值
        const lastValue = value[value.length - 1]
        // 存储到 formReason 字段
        this.$set(this.model, 'changingMeterReason', lastValue)
      }
    },
    displayRender({ labels }) {
      return labels[labels.length - 1]
    },
    // 根据最后一层值查找完整路径
    // 根据节点值查找完整路径
    findCascaderPath(leafValue) {
      const findPathRecursive = (node, path = []) => {
        // 判断当前节点是否匹配
        if (String(node.value) === String(leafValue)) {
          return [...path, node.value] // 返回当前路径
        }

        // 如果有子节点，继续递归查找
        if (node.children) {
          for (let child of node.children) {
            const result = findPathRecursive(child, [...path, node.value])
            if (result) {
              return result // 找到路径，返回
            }
          }
        }

        return null // 没找到，返回 null
      }

      // 遍历 options，查找路径
      for (let item of this.options) {
        const result = findPathRecursive(item)
        if (result) {
          return result // 找到路径，返回
        }
      }

      return [] // 如果没找到路径，返回空数组
    },
    getTagColor(value) {
      switch (value) {
        case 0:
          return 'red'
        case 1:
          return 'orange'
        case 2:
          return 'yellow'
        case 3:
          return 'blue'
        default:
          return 'default' // 你可以设置一个默认颜色
      }
    },
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    whetherSettlementOldTableChange() {
      if (this.model.whetherSettlementOldTable == 1 && this.model.meterOldMachineSumFlow != null) {
        this.meterOldMachineSumFlowInput()
      } else {
        this.$set(this.model, 'meterUserAccountNumAfterChange', null)
      }
    },
    payOrNotChange() {
      this.model.infoPicture = ''
    },
    viewSig() {
      this.visibleSig = true
    },
    handleSigCancel() {
      this.visibleSig = false
    },
    downloadSig() {
      this.downloadFile(this.formData.model.electronicSignature, this.$t('签名'))
    },
    downloadFile(url, name) {
      console.log('url==', url)
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    handleCancel1() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
}
</script>
<style scoped>
/* 二维码容器 */
.qrcode-wrapper {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  cursor: pointer;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
}

.qrcode-wrapper:hover {
  border-color: #1890ff;
}

/* 二维码图片 */
.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 悬浮提示文字 */
.qrcode-hover-text {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 4px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.qrcode-wrapper:hover .qrcode-hover-text {
  opacity: 1;
}

/* 底部信息栏 */
.qrcode-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
}

.qrcode-expire {
  color: #faad14;
}
</style>
<style lang="less" scoped>
.box-sig {
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-sig {
    visibility: hidden;
    position: absolute;
    width: 180px;
    height: 80px;
    top: 10px;
    left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;

    .icon-sig {
      color: rgba(255, 255, 255, 0.85);
      font-size: 16px;
    }
  }
  .mask-show {
    visibility: visible;
    transition: all 0.3s;
  }
}
</style>
